<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8"></base-header>

    <div class="container-fluid mt--9">
      <!-- Aviso de nueva versión -->
      <div class="new-version-banner">
        <div class="new-version-banner-msg">
          <i class="fas fa-rocket new-version-banner-icon"></i>
          <span>
            <strong>A partir del 2 de noviembre</strong> Claves de Autorización solo estará disponible en la <strong>nueva consola</strong>.
            Empieza a usarla desde ahora para familiarizarte y que el día del cambio no te tome por sorpresa.
          </span>
        </div>
        <div class="new-version-banner-actions">
          <button
            type="button"
            class="new-version-banner-help"
            @click.stop="showHelp = !showHelp"
          >
            <i class="fas fa-question-circle mr-1"></i>
            ¿Dónde la encuentro?
          </button>
          <a
            href="https://consola-v2.canplast.net/inicio?tool=authKeys"
            target="_blank"
            rel="noopener noreferrer"
            class="new-version-banner-link"
          >
            Ir a la nueva consola
            <i class="fas fa-external-link-alt ml-2"></i>
          </a>
        </div>

        <!-- Popover: cómo llegar a Claves dentro de la nueva consola -->
        <div v-if="showHelp" class="new-version-popover" @click.stop>
          <button
            type="button"
            class="new-version-popover-close"
            aria-label="Cerrar"
            @click="showHelp = false"
          >
            <i class="fas fa-times"></i>
          </button>
          <p class="new-version-popover-text">
            En la nueva consola abre el menú de herramientas con el ícono
            <i class="fas fa-th"></i> de arriba a la derecha y elige
            <strong>Claves</strong>. También puedes escribir «Claves» en el buscador.
          </p>
          <img
            src="img/nueva-consola-claves.png"
            alt="Menú de herramientas de la nueva consola con la opción Claves resaltada"
            class="new-version-popover-img"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-sm-8">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <h3 class="mb-0" style="padding-top:8px">Últimas autorizaciones generadas</h3>
            </div>
            <div class="card-body col-sm-">
              <div class="table-responsive">
                <base-table
                  striped
                  hover
                  thead-classes="thead-light"
                  :data="tableData"
                  style="table-layout: fixed;width:100%"
                >
                  <template slot="columns">
                    <th style="width:43%">Cliente / Proveedor</th>
                    <th style="width:15%">Generado por</th>
                    <th style="width:30%">Contraseña</th>
                  </template>

                  <template slot-scope="{ row }">
                    <td scope="row">
                      <span style="font-size:12px">{{ row.cardName }}</span>
                      <br />
                      <span class="text-muted" style="font-size:10px">{{ row.cardCode }}</span>
                    </td>
                    <td scope="row">
                      <span style="font-size:12px">{{ row.usuario }}</span>
                      <br />
                      <span class="text-muted" style="font-size:10px">{{ row.timestamp }}</span>
                    </td>
                    <td scope="row">
                      <span style="font-size:10px">{{ row.password }}</span>
                      <br />
                      <span class="text-muted" style="font-size:10px">Motivo: {{ row.motivo }}</span>
                      <br />
                      <div style="padding-top:4px">
                        <base-button
                          outline
                          type="default"
                          size="sm"
                          v-clipboard:copy="row.password"
                        >Copiar</base-button>
                      </div>
                    </td>
                  </template>
                </base-table>

                <center v-if="showLoader">
                  <img
                    src="img/loader.gif"
                    class="img-responsive"
                    style="width:50px;padding-bottom:5px;padding-top:13px"
                  />
                  <br />Cargando...
                </center>
                <div class="card-footer d-flex justify-content-end"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <h3 class="mb-0">Generar Autorización</h3>
            </div>
            <div class="card-body col-sm-">
              <div class="row">
                <div class="col-sm-12">
                  <h3 class="mb-0">TIPO DE AUTORIZACIÓN</h3>
                  <multiselect
                    v-model="tipoSelected"
                    :options="[{tipo:'Proveedor'}, {tipo:'Cliente'}]"
                    placeholder="Buscar"
                    label="tipo"
                    track-by="tipo"
                    @select="dispatchActionTipo"
                  ></multiselect>
                </div>
                <div class="col-sm-12" v-if="tipoSelected.tipo === 'Cliente'">
                  <br />
                  <h3 class="mb-0">SELECCIONA UN CLIENTE</h3>
                  <multiselect
                    v-model="selected"
                    :options="options"
                    placeholder="Buscar"
                    v-if="options.length > 0"
                    track-by="CardCode"
                    :custom-label="codigo_cliente"
                    @select="dispatchAction"
                  ></multiselect>
                  <center v-if="options.length === 0">
                    <img src="img/loader.gif" class="img-responsive" style="width:50px" />
                    <br />Cargando clientes...
                  </center>
                </div>
                <div class="col-sm-12" v-if="tipoSelected.tipo === 'Proveedor'">
                  <br />
                  <h3 class="mb-0">SELECCIONA UN PROVEEDOR</h3>
                  <multiselect
                    v-model="selected"
                    :options="optionsProveedor"
                    placeholder="Buscar"
                    v-if="options.length > 0"
                    track-by="CardCode"
                    :custom-label="codigo_cliente"
                    @select="dispatchAction"
                  ></multiselect>
                  <center v-if="options.length === 0">
                    <img src="img/loader.gif" class="img-responsive" style="width:50px" />
                    <br />Cargando proveedores...
                  </center>
                </div>
                <div class="col-sm-12">
                  <br />
                  <h3 class="mb-0">MOTIVO DE LA AUTORIZACIÓN</h3>
                  <textarea
                    class="form-control form-control"
                    v-model="motivo_contraseña"
                    rows="3"
                    placeholder="Escribe aquí tu mótivo ..."
                  ></textarea>
                </div>
              </div>
              <br />
              <base-button
                block
                @click="generar"
                :disabled="!selected || motivo_contraseña == ''"
              >GENERAR AUTORIZACIÓN</base-button>
              <center v-if="showLoaderGenerando">
                <img
                  src="img/loader.gif"
                  class="img-responsive"
                  style="width:50px;padding-bottom:5px;padding-top:13px"
                />
                <br />Generando autorización...
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import md5 from "md5-hash";
//  import SocialTrafficTable from './Dashboard/SocialTrafficTable';
import BTooltipDirective from "bootstrap-vue/es/directives/tooltip";
import moment from "moment";
import { getAuth, getIdToken } from "firebase/auth";
import {
  getFirestore,
  collection,
  query,
  orderBy,
  limit,
  getDocs,
  addDoc
} from "firebase/firestore";
import Multiselect from "vue-multiselect";
import axios from 'axios'

Vue.use(VueClipboard);
export default {
  components: {
    Multiselect,
    //        SocialTrafficTable,
  },
  directives: {
    "b-tooltip": BTooltipDirective,
  },
  created() {
    const auth = getAuth();
    this.user = auth.currentUser;
    getIdToken(auth.currentUser, true)
      .then((idToken) => {
        fetch("https://canplast.net:50000/api/v1/auth/verifyToken", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ token: idToken })
        })
          .then((response) => response.json())
          .then((responseJson) => {
            localStorage.setItem("token-cpm", responseJson.token);
          })
          .catch((error) => console.error(error));
      })
      .catch((error) => console.log(error));
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeHelp);
  },
  mounted() {
    document.addEventListener("click", this.closeHelp);
    fetch("https://canplast.net:50000/api/v1/sap/GET/BusinessPartners/short", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("token-cpm"),
      },
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.options = responseJson;
      })
      .catch((error) => {
        console.error(error);
      });

    axios
    .get(`/api/business_partners/suppliers`)
    .then((result) => {
      console.log("🚀 ~ file: PasswordGenerator.vue ~ line 221 ~ .then ~ result", result)
      this.optionsProveedor = result.data.value;
    })
    .catch((error) => {
      console.log(error);
    });

    const db = getFirestore();
    const passGenCol = collection(db, "PassGenerator");
    const q = query(passGenCol, orderBy("timestamp", "desc"), limit(100));
    getDocs(q)
      .then((querySnapshot) => {
        const array = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          array.push({
            cardCode: data.cardCode,
            cardName: data.cardName,
            password: data.password,
            timestamp: moment(data.timestamp, "x").format("YYYY-MM-DD HH:mm"),
            usuario: data.usuario,
            motivo: data.motivo
          });
        });
        this.tableData = array;
        this.showLoader = false;
        console.log(this.tableData);
      })
      .catch((error) => console.error(error));
  },
  data() {
    return {
      tableData: [],
      options: [],
      optionsProveedor: [],
      selected: null,
      tipoSelected: {
        tipo: 'Elige...',
      },
      showLoader: true,
      showLoaderGenerando: false,
      showCargarMasBtn: false,
      cedis_backlog: "CUU",
      slitter: "No",
      motivo_contraseña: "",
      showHelp: false,
    };
  },
  methods: {
    closeHelp() {
      this.showHelp = false;
    },
    codigo_cliente({ CardCode, CardName }) {
        return `${CardCode} - ${CardName}`;
    },
    dispatchActionTipo(){
      this.selected = null;
    },
    copyPassword(password) {
      var copyText = document.getElementById(password);
      copyText.select();
      document.execCommand("copy");
    },
    dispatchAction(prop) {
      console.log(prop);
      this.selected = prop;
    },
    cargarPasswords() {
      const db = getFirestore();
      const passGenCol = collection(db, "PassGenerator");
      const q = query(passGenCol, orderBy("timestamp", "desc"), limit(100));
      getDocs(q)
        .then((querySnapshot) => {
          const array = [];
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            array.push({
              cardCode: data.cardCode,
              cardName: data.cardName,
              password: data.password,
              timestamp: moment(data.timestamp, "x").format("YYYY-MM-DD HH:mm"),
              usuario: data.usuario,
              motivo: data.motivo
            });
          });
          this.tableData = array;
          this.showLoader = false;
        })
        .catch((error) => console.error(error));
    },
    generar() {
      const db = getFirestore();
      const passGenCol = collection(db, "PassGenerator");
      addDoc(passGenCol, {
        cardCode: this.selected.CardCode,
        cardName: this.selected.CardName,
        motivo: this.motivo_contraseña,
        usuario: this.user.displayName,
        password: md5(moment().format("YYYY-MM-DD") + this.selected.CardCode).toUpperCase(),
        timestamp: moment().format("x")
      })
        .then(() => {
          this.motivo_contraseña = "";
          this.selected = null;
          this.cargarPasswords();
          alert("Autorización generada");
        })
        .catch((error) => {
          alert("Hubo un error al generar la autorización");
        });
    },
  },
};
</script>
<style lang="scss">
/* Aviso de nueva versión */
/* position: relative para pintarse sobre .header y no quedar debajo de la franja roja */
.new-version-banner {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  box-sizing: border-box;
  min-height: 42px;
  margin-bottom: 14px;
  padding: 6px 18px;
  border-radius: 10px;
  border: 1px solid rgba($color: #f5365c, $alpha: 0.2);
  background: linear-gradient(135deg, #fff5f5 0%, #fff 100%);
  box-shadow: 0px 0px 12px rgba($color: #000000, $alpha: 0.06);
  color: #525f7f;
  font-size: 14px;
  line-height: 1.4;
}

.new-version-banner-msg {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.new-version-banner-msg strong {
  color: #32325d;
  margin-right: 4px;
}

.new-version-banner-icon {
  color: #f5365c;
  font-size: 18px;
}

.new-version-banner-link {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  padding: 8px 20px;
  border-radius: 99px;
  font-size: 13px;
  font-weight: 700;
  color: #fff !important;
  background: linear-gradient(87deg, #f5365c 0, #f55f36 200%);
  text-decoration: none;
  box-shadow: 0px 4px 12px rgba($color: #f5365c, $alpha: 0.3);
  transition: all 0.15s ease;
}

.new-version-banner-link:hover {
  transform: translateY(-1px);
  box-shadow: 0px 6px 18px rgba($color: #f5365c, $alpha: 0.4);
  text-decoration: none;
}

.new-version-banner-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
}

.new-version-banner-help {
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  background: none;
  font-size: 13px;
  font-weight: 600;
  color: #f5365c;
  white-space: nowrap;
  cursor: pointer;
}

.new-version-banner-help:hover {
  text-decoration: underline;
}

/* Popover anclado bajo el banner; el banner es position: relative */
.new-version-popover {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  z-index: 1050;
  width: 480px;
  max-width: calc(100vw - 48px);
  padding: 16px 18px 14px;
  border-radius: 12px;
  border: 1px solid rgba($color: #f5365c, $alpha: 0.2);
  background: #fff;
  box-shadow: 0px 10px 30px rgba($color: #000000, $alpha: 0.15);
  color: #525f7f;
  font-size: 13px;
  line-height: 1.5;
}

.new-version-popover::before {
  content: "";
  position: absolute;
  top: -7px;
  right: 90px;
  width: 12px;
  height: 12px;
  background: #fff;
  border-left: 1px solid rgba($color: #f5365c, $alpha: 0.2);
  border-top: 1px solid rgba($color: #f5365c, $alpha: 0.2);
  transform: rotate(45deg);
}

.new-version-popover-close {
  position: absolute;
  top: 8px;
  right: 10px;
  border: 0;
  background: none;
  color: #8898aa;
  font-size: 14px;
  cursor: pointer;
}

.new-version-popover-close:hover {
  color: #32325d;
}

.new-version-popover-text {
  margin: 0 22px 12px 0;
}

.new-version-popover-text strong {
  color: #32325d;
}

.new-version-popover-img {
  display: block;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
</style>
